import React from 'react'

export interface IconProps {
  size?: string | number
}

const AutopayIcon = ({ size = '31' }: IconProps) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    width={size}
    height={size}
    viewBox="0 0 31 31">
    <circle cx="15.5" cy="15.5" r="15.5" fill="#3f9c35" strokeWidth="0" />
    <path
      d="m15.5,5.17v-2.31c0-.58-.7-.87-1.1-.45l-3.62,3.6c-.26.26-.26.66,0,.92l3.6,3.6c.41.4,1.11.12,1.11-.47v-2.31c4.28,0,7.75,3.47,7.75,7.75,0,1.02-.19,2.02-.57,2.91-.19.47-.05.99.3,1.34.66.66,1.77.43,2.12-.44.48-1.18.74-2.47.74-3.81,0-5.71-4.62-10.33-10.33-10.33Zm0,18.08c-4.28,0-7.75-3.47-7.75-7.75,0-1.02.19-2.02.57-2.91.19-.47.05-.99-.3-1.34-.66-.66-1.77-.43-2.12.44-.48,1.18-.74,2.47-.74,3.81,0,5.71,4.62,10.33,10.33,10.33v2.31c0,.58.7.87,1.1.45l3.6-3.6c.26-.26.26-.66,0-.92l-3.6-3.6c-.4-.4-1.1-.12-1.1.47v2.31Z"
      fill="#fff"
      strokeWidth="0"
    />
    <circle cx="25.24" cy="25.24" r="4.37" fill="#fff" stroke="#3f9c35" />
    <path
      d="m28.08,24.1c.15.14.15.38,0,.52l-2.95,2.95c-.14.15-.38.15-.52,0l-1.48-1.48c-.15-.14-.15-.38,0-.52.14-.15.38-.15.52,0l1.21,1.21,2.7-2.69c.14-.15.38-.15.52,0Z"
      fill="#3f9c35"
      strokeWidth="0"
    />
  </svg>
)

export default AutopayIcon
